import { AchievementDefinition } from '../services/GameAPI';

export const MELODY_SHAPER_ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: "melody-shaper-first-try",
    gameId: "melody-shaper",
    title: "First Try!",
    description: "Guessed the melody shape correctly on your very first attempt.",
    iconUrl: "🎯",
    museCashReward: 25,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 1,
    category: "skill"
  },
  {
    id: "melody-shaper-first-point",
    gameId: "melody-shaper",
    title: "On the Board",
    description: "Earned your first point in Melody Shaper.",
    iconUrl: "✅",
    museCashReward: 10,
    type: "progression",
    rarity: "common",
    implemented: true,
    sortOrder: 2,
    category: "progression"
  },
  {
    id: "melody-shaper-score-2",
    gameId: "melody-shaper",
    title: "Level Up!",
    description: "Reached a score of 2.",
    iconUrl: "📈",
    museCashReward: 15,
    type: "progression",
    rarity: "common",
    implemented: true,
    sortOrder: 3,
    category: "progression"
  },
  {
    id: "melody-shaper-score-5",
    gameId: "melody-shaper",
    title: "Ear for Music",
    description: "Reached a score of 5. You're getting the hang of this!",
    iconUrl: "👂",
    museCashReward: 25,
    type: "progression",
    rarity: "rare",
    implemented: true,
    sortOrder: 4,
    category: "progression"
  },
  {
    id: "melody-shaper-streak-10",
    gameId: "melody-shaper",
    title: "Hot Streak",
    description: "Guessed 10 melody shapes correctly in a row.",
    iconUrl: "🔥",
    museCashReward: 100,
    type: "skill",
    rarity: "rare",
    implemented: true,
    sortOrder: 5,
    category: "skill"
  },
  {
    id: "melody-shaper-score-10",
    gameId: "melody-shaper",
    title: "Melody Novice",
    description: "Reached a score of 10. You've unlocked harder melodies!",
    iconUrl: "🎓",
    museCashReward: 50,
    type: "progression",
    rarity: "rare",
    implemented: true,
    sortOrder: 6,
    category: "progression"
  },
  {
    id: "melody-shaper-score-20",
    gameId: "melody-shaper",
    title: "Shape Expert",
    description: "Reached a score of 20.",
    iconUrl: "🌟",
    museCashReward: 100,
    type: "progression",
    rarity: "epic",
    implemented: true,
    sortOrder: 7,
    category: "progression"
  },
  {
    id: "melody-shaper-score-50",
    gameId: "melody-shaper",
    title: "Contour Champion",
    description: "Reached a score of 50. A true master of melodic shapes!",
    iconUrl: "🏆",
    museCashReward: 250,
    type: "progression",
    rarity: "legendary",
    implemented: true,
    sortOrder: 8,
    category: "progression"
  }
]; 